import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Contact: React.FC = () => {
  const { t } = useTranslation();

  const contactInfo = [
    {
      title: t('contact.phone'),
      content: "+90 532 415 5992",
      link: "tel:+905324155992"
    },
    {
      title: t('contact.email'),
      content: "info@symbasecuretech.com",
      link: "mailto:info@symbasecuretech.com"
    },
    {
      title: t('contact.address'),
      content: t('contact.addressText'),
      link: null
    }
  ];

  return (
    <section id="contact" className="section contact-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">{t('contact.title')}</h2>
          <p className="section-subtitle">
            {t('contact.subtitle')}
          </p>
        </motion.div>

        <motion.div
          className="contact-info"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {contactInfo.map((item, index) => (
            <motion.div
              key={index}
              className="contact-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <h4>{item.title}</h4>
              {item.link ? (
                <a href={item.link}>{item.content}</a>
              ) : (
                <p>{item.content}</p>
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;